import styled from 'styled-components';

interface StyledAppContainerProps {
  $fullWidth: string | null;
}

const StyledAppContainer = styled.div<StyledAppContainerProps>`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 20px;
  height: calc(100vh - 20px);
  justify-content: flex-end;
  box-sizing: border-box;
  width: 100%;
  max-width: ${(props) => props.$fullWidth ? '874px' : 'auto'};
  margin: ${(props) => props.$fullWidth ? '0 auto' : 'initial'};
`;

export default StyledAppContainer;